import React, { useState } from 'react'

import {v4 as uuid4} from "uuid";
import SideBarItem  from './SideBarItem';



const sideBarItemArray=[{
  id:"home",
  displayText:"Home",
  select:true,
  icon:"ti ti-home",
  navigate:"/Home",
  target:"_self",
  rel:"noreferrer"
},
{
  id:"jobApc",
  displayText:"Jobs Applications",
  select:false,
  icon:"ti ti-file-description",
  navigate:"/job-applications",
  target:"_self",
  rel:"noreferrer"
}
,{
  id:"createJobPost",
  displayText:"Create New Job Post",
  select:false,
 navigate:"/all-job-posts",
 icon:"ti ti-lock",
 target:"_self",
 rel:"noopener noreferrer"
},{
  id:"jobPosts",
  displayText:"All Job Posts",
  select:false,
  icon:"ti ti-file-database",
  navigate:"/jobs",
  rel:"noreferrer",
  target:"_self",
},
{
  id:uuid4(),
  displayText:"ContactUs Form",
  select:false,
  icon:"ti ti-file-report",
  navigate:"/contact-form",
  rel:"noreferrer",
  target:"_self",
}
// {
//   id:uuid4(),
//   displayText:"Logout",
//   select:false,
//   icon:"ti ti-file-spreadsheet",
//   navigate:"/login",
//   rel:"noreferrer",
//   target:"_self"
// }
]
function SideBar() {
  const[activeTab,setActiveTab]=useState(sideBarItemArray[0].id); 
  const   logout=()=>{
    sessionStorage.setItem("loggedin", "false");
    window.location.href = "/login";
  }

  const handleTabId=(id)=>{
    setActiveTab(id)

  }


  return (

<>
  {/* Sidebar Start */}
  <aside className="left-sidebar">
    {/* Sidebar scroll*/}
    <div  style={{backgroundColor:"#0f172a"}}>
      <div className="brand-logo d-flex align-items-center justify-content-center mb-3 ">
        <a href="/home" className="text-nowrap logo-img">
          <img src="../assets/images/logo.jpg" width={240} height={50} alt="" className='rounded mt-3'/>
        </a>
        <div
          className="close-btn d-xl-none d-block sidebartoggler cursor-pointer"
          id="sidebarCollapse"
        >
          <i className="ti ti-x fs-8" />
        </div>
      </div>
      {/* Sidebar navigation*/}
        <nav className="sidebar-nav scroll-sidebar mt-1 w-100  bg-primary" data-simplebar="" >
   <ul id="sidebarnav" className='bg-primary rounded pb-3 pt-4 h-75 w-100' style={{width:"100"}}>

       {
        sideBarItemArray.map((item)=>(<SideBarItem Item={item} key={item.id}  isActive={item.id===activeTab}
        onClick={handleTabId}/>))
     }
     <li className="sidebar-item"  aria-expanded="false"  onClick={() => logout()}>
      <p className='sidebar-link'>
      <span>
        <i className="ti ti-logout text-white"  />
      </span>
      <span className="hide-menu fs-4 text-white">Logout</span>
      </p>
      
    
  </li>
 
   </ul>
  
  </nav>
    
      {/* End Sidebar navigation */}
    </div>
    {/* End Sidebar scroll*/}
  </aside>
  {/*  Sidebar End */}
</>

  )
}

export default SideBar;